// Updated NoteDialog.tsx
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
} from '@mui/material';
import moment from 'moment';

interface NoteDialogProps {
  initialNote: string;
  user_name: string;
  updated_at: string;
  open: boolean;
  onClose: () => void;
  onSend: (note: string) => void;
}

const NoteDialog: React.FC<NoteDialogProps> = ({
  initialNote,
  user_name,
  updated_at,
  open,
  onClose,
  onSend,
}) => {
  const [note, setNote] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setNote(''); 
    }
  }, [open]);

  const handleRemove = () => {
    setNote('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      classes={{ paper: 'dialog-paper' }}
    >
      <DialogContent className="dialog-content">
        <Box className="header" 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1, 
          width: '100%',
          variant:"body1",
          fontWeight: 'bold'
        }}>
          <Box onClick={onClose} sx={{ cursor: 'pointer' }}>
            <Typography color = "#0000a0" sx={{fontWeight: 'bold'}} >
              {'<'} Back
            </Typography>
          </Box>
          <Typography sx={{fontWeight: 'bold'}}>
            Comments 
          </Typography>
        </Box>

        {/* Existing Note Section - Only show if there's an existing note */}
        {initialNote && initialNote.trim() !== '' && (
          <Box className="note-box" sx={{ mb: 2, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, mt:2 }}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 1,
            }}>
              <Typography fontSize="10px" color="#656565" fontWeight={700}>
                {`Sent by: ${user_name || 'Unknown User'}`}
              </Typography>
              <Typography fontSize="12px" fontWeight={700}>
                {updated_at ? `Date: ${moment(updated_at).format('DD/MM/YYYY h:mm A')}` : ''}
              </Typography>
            </Box>
            
            <Typography 
              variant="body2" 
              className="note-content"
              sx={{ 
                wordWrap: 'break-word', 
                whiteSpace: 'pre-wrap', 
                overflowWrap: 'break-word',
                backgroundColor: '#f5f5f5',
                p: 1,
                borderRadius: 1,
              }}
            >
              {initialNote}
            </Typography>
          </Box>
        )}

        {/* New Note Input Section */}
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 , mt: 1}}>
            {initialNote && initialNote.trim() !== '' ? 'Add a reply:' : 'Add a comment:'}
          </Typography>
          <TextField
            value={note}
            onChange={(e) => setNote(e.target.value)}
            multiline
            fullWidth
            minRows={4}
            placeholder="Type your comment here..."
            className="text-field"
            color="primary"
            disabled={isLoading}
          />
        </Box>
      </DialogContent>

      <DialogActions className="dialog-actions">
        {/* <Button 
          onClick={handleRemove} 
         // variant="outlined" 
          className="remove-button"
          disabled={isLoading}
        >
          Remove
        </Button> */}
        <Button
          onClick={() => onSend(note)}
          variant="contained"
          className="send-button"
          disabled={note.trim() === '' || isLoading}
        >
          {isLoading ? 'Sending...' : 'Send'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteDialog;